import { Component, Input } from '@angular/core';
import { Tooltip } from '../../../shared/models/Tooltip';
import { Constants } from '../../../shared/utilities/Constants';
import { CashBalance, CashType } from '../../models';

@Component({
  standalone: false,
  selector: 'mm-cash-balance',
  templateUrl: './cash-balance.component.html',
  styleUrls: ['./cash-balance.component.scss']  
})

export class CashBalanceComponent {
  @Input() balance: CashBalance;
  @Input() formerTdaIndicator: boolean;
  availableCashTooltipVerbiage: string = Constants.availableCash;
  contributionYtdTooltipVerbiage: string = Constants.contributionYTD;
  unsettledCashTooltipVerbiage: string = Constants.unsettledCash;
  distributionTooltipVerbiage: string = Constants.tdaIraDistributionWarning;
  contributionTooltipVerbiage: string = Constants.tdaIraContributionWarning;

  get cashBalanceClass(): string {
    if (this.displayTooltip) {
      return 'cash-amount-tooltip'
    } else if (this.displayTdaTooltip) {
      return 'tda-amount-tooltip'
    } else {
      return 'cash-amount'
    }
  }

  isNumber(val: number | string): boolean {
    return typeof val === 'number';
  }

  get displayTooltip(): boolean {
    return this.balance.type === CashType.Available || this.balance.type === CashType.Unsettled || this.balance.type === CashType.contributionYtd;;
  }

  get displayTdaTooltip(): boolean {
    return this.formerTdaIra && this.balance.type === CashType.RmdYtd;
  }

  get formerTdaIra(): boolean {
    return this.formerTdaIndicator && (this.balance.type === CashType.RmdYtd || this.balance.type === CashType.contributionYtd);
  }

  get tooltipVerbiage(): string {
    return this.balance.type === CashType.Available ? this.availableCashTooltipVerbiage : (this.balance.type === CashType.contributionYtd ? this.contributionYtdTooltipVerbiage : this.unsettledCashTooltipVerbiage);
  }

  get formerTdaIraVerbiage(): string {
    return this.balance.type === CashType.RmdYtd ? this.distributionTooltipVerbiage : this.contributionTooltipVerbiage;
  }
}
